module.exports = __webpack_public_path__ + "static/img_1131-4ac3a3e61bb48632dabc6df9f34d0a85.webp";